function isIndexSortable(model) {
    // noinspection SuspiciousTypeOfGuard
    return model && typeof model.index === 'number';
}
function isStartSortable(model) {
    // noinspection SuspiciousTypeOfGuard
    return model && model.start instanceof Date;
}
/**
 *  @internal Used to sort a collection of models. It first tries
 *  to sort them based on index, otherwise based on start.
 *
 *  (!) Even though returning A - B seems to be faster in FireFox and Safari
 *  based on a performance test - instead of returning 0 when A === B - the
 *  latter seems to be faster in practice for also FireFox and Safari.
 */
export default function modelSort(modelA, modelB) {
    // First try to sort on index
    if (isIndexSortable(modelA) && isIndexSortable(modelB)) {
        return modelA.index === modelB.index
            ? 0
            : (modelA.index < modelB.index ? -1 : 1);
    }
    // Secondly try to sort on start (date)
    if (isStartSortable(modelA) && isStartSortable(modelB)) {
        const timeA = modelA.start.getTime();
        const timeB = modelB.start.getTime();
        return timeA === timeB ? 0 : timeA - timeB;
    }
    return 0;
}
//# sourceMappingURL=modelSort.js.map